import {
  SIGN_IN_USER,
  LOG_OUT,
  AUTHENTICATE_USER_SUCCESS,
  SET_NOT_FIRST_TO_SELECT_PAGE,
} from '../constants';
import {deleteCredentials} from '../../utilities/localStorage';
import {pushRoute} from '../../utilities/helpers';

export const signInUser = (username, password) => ({
    type: SIGN_IN_USER,
    username,
    password,
  });

export const authenticateUser = (token,selectedIdx) =>({
  type: AUTHENTICATE_USER_SUCCESS,
  token,
  selectedIdx
})

export const setNotfirstToSelectPage = () =>({
  type: SET_NOT_FIRST_TO_SELECT_PAGE,
})

export const logOut = () => {
  deleteCredentials();
  pushRoute('/login')
  return {type: LOG_OUT}
};
